import React from "react";
import { Formik, Form } from "formik";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FilterFields from "./fields/FilterFields";

const FILTERS = "filters";

export default function AssetFieldFilterModal({ value = [], onSave, onClose }) {
  const handleSave = values => {
    onSave(values[FILTERS]);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography fontSize={20} fontWeight={500} color="text.primary" align="center">
          Asset Field Filters
        </Typography>
        <IconButton
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Formik initialValues={{ [FILTERS]: value }} onSubmit={handleSave} enableReinitialize>
        {({ submitForm }) => (
          <Form>
            <DialogContent>
              <FilterFields name={FILTERS} />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={submitForm}>
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
